import { render, staticRenderFns } from "./finStrategyEtfDetails.vue?vue&type=template&id=989bad9e&scoped=true&"
import script from "./finStrategyEtfDetails.vue?vue&type=script&lang=js&"
export * from "./finStrategyEtfDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989bad9e",
  null
  
)

export default component.exports